import { Link } from "react-router-dom";
import { Mail, Phone, ArrowUpRight } from "lucide-react";

const LOGO = "https://customer-assets.emergentagent.com/job_ops-framework/artifacts/p53i8p5i_ChatGPT%20Image%20May%205%2C%202026%2C%2007_55_14%20PM.png";

export default function Footer() {
  return (
    <footer className="bg-[#0A192F] text-white" data-testid="site-footer">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12 py-16 lg:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 bg-white px-3 py-2 w-fit">
              <img src={LOGO} alt="Backbench" className="h-9 w-auto" data-testid="footer-logo" />
            </div>
            <p className="mt-6 text-2xl lg:text-3xl font-extrabold tracking-tight leading-snug max-w-md">
              Operational businesses. Properly run.
            </p>
            <p className="mt-4 text-sm text-white/60 max-w-md leading-relaxed">
              Fractional operations, systems, AI and governance support for trade and service businesses.
            </p>
          </div>

          <div className="lg:col-span-3">
            <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#F68712]">
              Pages
            </div>
            <ul className="mt-6 space-y-3">
              {[
                { to: "/", label: "Home" },
                { to: "/what-we-do", label: "What We Do" },
                { to: "/who-its-for", label: "Who It's For" },
                { to: "/how-it-works", label: "How It Works" },
                { to: "/about", label: "About" },
                { to: "/contact", label: "Contact" },
              ].map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="text-sm text-white/80 hover:text-white inline-flex items-center gap-1 transition-colors"
                    data-testid={`footer-${l.label.toLowerCase().replace(/[^a-z]+/g, "-").replace(/^-|-$/g, "")}-link`}
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#F68712]">
              Get in touch
            </div>
            <ul className="mt-6 space-y-4">
              <li>
                <a
                  href="mailto:hello@backbench.co.nz"
                  className="group flex items-center gap-3 text-base font-semibold hover:text-[#F68712] transition-colors"
                  data-testid="footer-email-link"
                >
                  <Mail size={18} strokeWidth={1.75} />
                  <span>hello@backbench.co.nz</span>
                  <ArrowUpRight size={16} className="opacity-0 group-hover:opacity-100 transition-opacity" />
                </a>
              </li>
              <li>
                <a
                  href="tel:+64272315706"
                  className="group flex items-center gap-3 text-base font-semibold hover:text-[#F68712] transition-colors"
                  data-testid="footer-phone-link"
                >
                  <Phone size={18} strokeWidth={1.75} />
                  <span>027 231 5706</span>
                </a>
              </li>
            </ul>
            <Link
              to="/contact"
              className="mt-8 inline-flex items-center justify-center bg-[#F68712] hover:bg-[#D87410] text-white font-bold tracking-wide px-6 py-3 transition-colors duration-200"
              data-testid="footer-cta-book-call"
            >
              Book a Free Call
            </Link>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <p className="text-xs text-white/50">
            © {new Date().getFullYear()} Backbench. All rights reserved.
          </p>
          <p className="text-xs text-white/50 font-mono tracking-wider">
            BACKBENCH.CO.NZ — AOTEAROA, NEW ZEALAND
          </p>
        </div>
      </div>
    </footer>
  );
}
